export default function mdEmphasis() {
    document.querySelectorAll(".gh-md").forEach((el) => {
        const raw = el.textContent;
        if (raw.indexOf("*") === -1) return;
        const esc = raw
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;");
        el.innerHTML = esc.replace(/\*([^*]+)\*/g, "<em>$1</em>");
    });
}
